import './index.scss';
import 'components/empty_list_message';
import 'components/select';
import { errorInterpreter } from 'utils/error_interpreter';

const errorMapping = {
  1: {
    title: 'O enunciado ou as alternativas estão diferentes da prova oficial?',
    subtitle:
      'Se o enunciado ou as alternativas estiverem diferentes do conteúdo oficial, vamos analisar e corrigir conforme a prova liberada pela banca.',
    btnLabel: 'Reportar erro'
  },
  2: {
    title: 'Esse gabarito está diferente do oficial divulgado pela banca?',
    subtitle:
      'Caso o gabarito oficial, divulgado pela banca, seja outro, faremos a correção após análise e confirmação.',
    btnLabel: 'Reportar erro'
  },
  3: {
    title: 'A disciplina ou assunto desta questão está incorreto?',
    subtitle:
      'Se você identificou que esta questão pertence a outra disciplina ou assunto, vamos revisar e ajustar em conformidade com a orientação dos professores.',
    btnLabel: 'Sugerir nova classificação'
  },
  4: {
    title: 'Esta questão foi oficialmente anulada pela banca?',
    subtitle:
      'Se a banca responsável pela prova anulou oficialmente a questão, faremos a correção após verificação dos documentos oficiais.',
    btnLabel: 'Reportar anulação oficial'
  },
  5: {
    title: 'Esta questão está desatualizada ou fora de contexto atual?',
    subtitle:
      'Se houve mudanças legais ou contextuais que invalidam o conteúdo, realizaremos a atualização após análise das fontes oficiais ou referências recentes.',
    btnLabel: 'Reportar conteúdo desatualizado'
  },
  6: {
    title:
      'Esta questão é duplicada e possui enunciado e alternativas idênticas?',
    subtitle:
      'Se a questão tiver enunciado, alternativas e gabarito iguais a outra existente, unificaremos as informações e evitaremos duplicidades.',
    btnLabel: 'Reportar questão duplicada'
  }
};

// Bloqueia reenvio na mesma questão durante a sessão da página,
// sem impedir notificação em outras questões.
const notifiedQuestionIds = new Set();

class QuestionNotifyTab {
  constructor($context) {
    this.$context = $context;
    this.$createForm = $('.q-create-form', this.$context);
    this.$errorSelectionScreen = $('.js-error-selection', this.$context);
    this.$errorDetailsScreen = $('.js-error-details', this.$context);
    this.$alreadyNotifiedScreen = $('.js-already-notified', this.$context);
    this.$backButton = $('.js-back-button', this.$context);
    this.$enableSubmitCheckbox = $('.js-enable-submit', this.$context);
    this.$submitButton = $('.js-submit-btn', this.$context);
    this.$description = $('.js-error-description', this.$context);
    this.isSubmitting = false;
    this.questionId = String(
      this.$createForm
        .find('input[name="question_error[question_id]"]')
        .val() || ''
    );
    this.handleErrorTypeChange();
    this.bindEvents();

    if (notifiedQuestionIds.has(this.questionId)) {
      this.lockAfterNotify();
    }
  }

  resetSubmittingState() {
    this.isSubmitting = false;
    this.$submitButton.prop(
      'disabled',
      !this.$enableSubmitCheckbox.prop('checked')
    );
  }

  alreadyNotified() {
    return notifiedQuestionIds.has(this.questionId);
  }

  createNotification() {
    if (this.alreadyNotified()) {
      this.resetSubmittingState();
      const errorMessage = this.$createForm.data('errorMessage');

      if (errorMessage) {
        toastr.error(errorMessage);
      }
      this.lockAfterNotify();
      return;
    }

    const data = this.$createForm.serializeObject();

    if (data.question_error) {
      data.question_error.report_url = window.location.href;
    }
    const description = this.$description.get(0);
    const hasType = data.question_error && data.question_error.type != null;

    if (!hasType) {
      this.$errorDetailsScreen.addClass('hidden');
      this.$errorSelectionScreen.removeClass('hidden');
      this.resetSubmittingState();
      return;
    }

    if (!description || description.value.trim() === '') {
      if (description) {
        description.setCustomValidity(description.getAttribute('title'));
        description.reportValidity();
      }
      this.resetSubmittingState();
      return;
    }

    Thor.QuestionError.create({}, { data })
      .then(() => {
        this.isSubmitting = false;
        notifiedQuestionIds.add(this.questionId);

        if (window.Intercom) {
          window.Intercom('update', {
            'Último recurso com erro notificado': 'Questão',
            'Informação do recurso com erro notificado': this.questionId
          });
        }

        const successMessage = this.$createForm.data('successMessage');

        if (successMessage) {
          toastr.success(successMessage);
        }

        this.lockAfterNotify();
      })
      .catch(({ response }) => {
        this.resetSubmittingState();
        // Mensagens específicas da API via errorInterpreter.
        // Sem ajax:error para não duplicar toast genérico.
        errorInterpreter({
          message: 'Ops! Não foi possível criar a notificação nesse momento!',
          response
        });
      });
  }

  lockAfterNotify() {
    this.$description.val('');
    this.$enableSubmitCheckbox.prop('checked', false);
    this.$submitButton.prop('disabled', true);
    $('input[name="question_error[type]"]', this.$context).prop(
      'checked',
      false
    );
    this.$errorDetailsScreen.addClass('hidden');
    this.$errorSelectionScreen.addClass('hidden');
    this.$alreadyNotifiedScreen.removeClass('hidden');
    this.$createForm.find('input, textarea, button').prop('disabled', true);
  }

  handleErrorTypeChange() {
    $('input[name="question_error[type]"]', this.$context).each((_, radio) => {
      $(radio)
        .off('change.questionNotify')
        .on('change.questionNotify', () => {
          if (!radio.checked || this.alreadyNotified()) {
            return;
          }

          const errorText = errorMapping[radio.value];
          $('h2.error-description', this.$context).text(errorText?.title);
          $('p.error-description', this.$context).text(errorText?.subtitle);

          this.$submitButton.text(errorText?.btnLabel);
          this.showErrorDetails();
        });
    });
  }

  showErrorDetails() {
    this.$errorSelectionScreen.addClass('hidden');
    this.$errorDetailsScreen.removeClass('hidden');
  }

  resetForm() {
    if (this.alreadyNotified()) {
      this.lockAfterNotify();
      return;
    }

    $('input[name="question_error[type]"]', this.$context).prop(
      'checked',
      false
    );
    this.$enableSubmitCheckbox.prop('checked', false);
    this.$submitButton.prop('disabled', true);
  }

  bindEvents() {
    this.$backButton
      .off('click.questionNotify')
      .on('click.questionNotify', () => {
        this.$errorSelectionScreen.removeClass('hidden');
        this.$errorDetailsScreen.addClass('hidden');
        this.resetForm();
      });

    this.$enableSubmitCheckbox
      .off('change.questionNotify')
      .on('change.questionNotify', () => {
        if (this.alreadyNotified()) {
          this.$submitButton.prop('disabled', true);
          return;
        }

        this.$submitButton.prop(
          'disabled',
          !this.$enableSubmitCheckbox.prop('checked')
        );
      });

    // clearOnSuccess=false evita clearForm + change nos radios
    this.$createForm
      .ajaxForm(false)
      .lazyReady()
      .off('submit.questionNotify')
      .on('submit.questionNotify', e => {
        e.preventDefault();

        if (this.isSubmitting) {
          return false;
        }
        this.isSubmitting = true;
        this.$submitButton.prop('disabled', true);
        this.createNotification();
        return false;
      });
  }
}

(function () {
  'use strict';

  $(document)
    .off('componentLoaded:questions/question_notify')
    .on('componentLoaded:questions/question_notify', (e, data) => {
      $('.q-select-input', data.context).qselect();
      new QuestionNotifyTab(data.context);
    });
})(jQuery);
